<template>
  <b-container fluid>
    <b-form-row>
      <b-col lg="2" md="6" sm="12">
        <b-form-group v-bind:id="'qty-' + key" 
        :label="quantity_index == 0 ? 'Quantity:' : ''" 
        v-bind:label-for="'input-qty-' + key">
          <b-input-group>
            <b-form-input
              size="sm"
              v-bind:id="'input-qty-' + key"
              v-model="response.qty"
              type="number"
              min="1"
              placeholder="Enter Quantity"
              :number="true"
              :state="response.qty != null &&  response.qty > 0"
              :readonly="response.rfq_line_quantity_id != null"
            ></b-form-input>
            
          </b-input-group>
        </b-form-group>
      </b-col>
      
      <b-col lg="2" md="6" sm="12">
        <b-form-group v-bind:id="'uom-' + key" 
        :label="quantity_index == 0 ? 'UOM:' : ''"
        v-bind:label-for="'input-uom-' + key">
          <b-form-input
              size="sm"
            v-bind:id="'input-uom-' + key"
            v-model="response.uom"
            placeholder="Enter UOM"
            :state="(response.uom != null && response.uom.trim().length > 0)"
            :readonly="response.rfq_line_quantity_id != null"
          ></b-form-input>
        </b-form-group>
      </b-col>
      
      <b-col lg="2" md="6" sm="12">
        <b-form-group v-bind:id="'lead_time-' + key" 
        :label="quantity_index == 0 ? 'Lead Time:' : ''" 
        v-bind:label-for="'input-lead_time-' + key">
          <b-input-group append="Days" size="sm">
            <b-form-input
              size="sm"
              v-bind:id="'input-lead_time-' + key"
              v-model="response.lead_time"
              type="number"
              min="0"
              step="1"
              placeholder="# days"
              :number="true"
              :state="((response.lead_time != null && response.lead_time >= 0 && response.lead_time != '') || response.no_quote == true)"
              :readonly="response.no_quote"
              oninput="this.value = Math.round(this.value);"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col lg="2" md="6" sm="12">
        <b-form-group v-bind:id="'cost-' + key" 
        :label="quantity_index == 0 ? 'Unit Cost:' : ''"
        v-bind:label-for="'input-cost-' + key">
          <b-input-group prepend="$" size="sm">
            <b-form-input
              size="sm"
              v-bind:id="'input-cost-' + key"
              v-model="response.cost"
              type="number"
              min="0"
              step="any"
              placeholder="Enter Unit Cost"
              :number="true"
              :state="((response.cost != null && response.cost != '' && response.cost >= 0) || response.no_quote == true)"            
              :readonly="response.no_quote"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>

      <!-- Condition dropdown selector -->
      <b-col lg="2" md="6" sm="12">
        <b-form-group v-bind:id="'condition-' + key" 
        :label="quantity_index == 0 ? 'Condition:' : ''" 
        v-bind:label-for="'input-condition-' + key">
          <b-form-select
            size="sm"
            v-bind:id="'input-condition-' + key"
            v-model="response.condition"
            placeholder="Condition of Parts"
            :options="line_condition_options"
            :disabled="response.no_quote"
          ></b-form-select>        
        </b-form-group>
      </b-col>

      
      <!-- Button to delete a quantity created by vendor -->
      <b-col lg="2" md="6" sm="12"
        v-if="response.rfq_line_quantity_id == null"      
      >
         <b-form-group label="">
         <b-button  
              size="sm"
         block 
         variant="danger" 
         v-on:click="$emit('removeQuantity', line_index, quantity_index)"
         v-b-tooltip.hover.bottom.v-secondary title="Remove this quantity line"
         ><i class="fa fa-trash"></i></b-button>
         </b-form-group>
      </b-col>

      <!-- Checkbox button to toggle "No-Quote" or "Quoting" for quantities from original solicitation --> 
      <b-col lg="2" md="6" sm="12"
        v-else     
      >
        <div class="my-buttons">
        <b-form-group 
        :label="quantity_index == 0 ? 'No-Quote:' : ''"
        >
          <b-form-checkbox 
            size="lg"            
            v-model="response.no_quote" 
            name="check-button" 
            switch
            v-on:change="quantityNoQuoteChanged(quantity_index)"
            v-b-tooltip.hover.bottom.v-secondary title="Original solicitation quantities cannot be deleted/changed, but you can no-quote them."
            >             
          </b-form-checkbox>         
         </b-form-group>
         </div>
      </b-col>
    </b-form-row>

    <b-form-row v:if="custom_fields.length > 0">
      <b-col lg="3" md="6" sm="12" v-for="(response_custom_field, custom_fields_index) in custom_fields" :key="custom_fields_index">
        <b-form-group v-bind:id="custom_fields_index + key" v-bind:label="response_custom_field" v-bind:label-for="'input-' + custom_fields_index + '-' + key">
          <b-form-input
            v-bind:id="'input-' + custom_fields_index + '-' + key"
            v-model="response.custom_fields[response_custom_field]"
            placeholder="(optional)"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>

  </b-container>
</template>

<script>
export default {
  name: 'rfq-quantity-form',
  props: [
    'response',
    'id',
    'quantity_index',
    'line_index',
    'line_condition_options'
  ],
  computed: {
    key: function () {
      return 'rfq_quantity_' + this.id
    },
    custom_fields: function () {
      let custom_field_keys = {};
      if (this.response.custom_fields) {
        custom_field_keys = Object.keys(this.response.custom_fields);
      }
      return custom_field_keys;
    }
  },

  methods: {
    quantityNoQuoteChanged: function(quantity_index)
    {
      this.response.lead_time = null;
      this.response.cost = null;
      this.response.condition = 'NEW';
      console.log(this.response);
    }
  },

  mounted() {
    console.log(this.response);
    if(this.response.condition == undefined)
    {
      this.response.condition = "NEW";
    }

  }
}
</script>

<style scoped>
  .my-buttons .active {
    color: #fff !important;
    background-color: #28a745 !important;
    border-color: #28a745 !important;
  }

.form-group {
  margin-bottom: 0.3rem;
}
</style>